/**
 * ThermostatSetMode Style04 - Segmented control
 */
import type { TraitControlProps } from './types'

const MODES = [
  { id: 'cool', label: 'Cool' },
  { id: 'heat', label: 'Heat' },
  { id: 'dry', label: 'Dry' },
  { id: 'fan-only', label: 'Fan' },
  { id: 'auto', label: 'Auto' },
] as const

export function ThermostatSetModeStyle04({
  state,
  onCommand,
  disabled = false,
}: TraitControlProps) {
  const raw = (state?.thermostatMode ?? state?.mode ?? state?.currentModeSettings) as string | undefined
  const current = typeof raw === 'string' ? raw.toLowerCase() : 'cool'
  const normalized = MODES.some((m) => m.id === current) ? current : 'cool'

  return (
    <div className="smart-home-automation-field">
      <label>Mode</label>
      <div className="smart-home-automation-segmented">
        {MODES.map((m) => (
          <button
            key={m.id}
            type="button"
            className={normalized === m.id ? 'active' : ''}
            onClick={() => !disabled && onCommand('setMode', { mode: m.id })}
            disabled={disabled}
          >
            {m.label}
          </button>
        ))}
      </div>
    </div>
  )
}
